import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HomeComponent } from "./home.component";
import { HomeRoutingModule } from "./home.routing";
import { NzCardModule } from "ng-zorro-antd/card";
import { NzAvatarModule } from "ng-zorro-antd/avatar";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzTabsModule } from "ng-zorro-antd/tabs";
import { NzMessageModule } from "ng-zorro-antd/message";
import { NzGridModule } from "ng-zorro-antd/grid";
import { CardModule } from "primeng/card";
import { NzIconModule } from "ng-zorro-antd/icon";
import { MatDividerModule } from "@angular/material/divider";
@NgModule({
  declarations: [HomeComponent],
  imports: [
    CommonModule,
    HomeRoutingModule,
    NzCardModule,
    NzGridModule,
    NzMessageModule,
    NzButtonModule,
    NzAvatarModule,
    NzTabsModule,
    CardModule,
    NzIconModule,
    MatDividerModule,
  ],
  exports: [],
  providers: [],
})
export class HomeModule {}
